module.exports = __webpack_public_path__ + "static/media/icon-grid.54bec007.svg";